// Dynamic imports
const AudioPlayer = () => import('@/views/audio/AudioPlayer.vue')

export const audioRoutes = [
  {
    path: '/audio',
    name: 'audio',
    component: AudioPlayer,
    props: route => ({ url: route.query.url }),
    meta: {
      title: 'Audio Player',
      requiresAuth: true
    }
  }
]
